import React, { useEffect, useState } from "react";
import { Flex, Typography, Tabs, Spin } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BackButton from "../../components/CustomButton/BackButton";
import CustomCard from "../../components/CustomCard/CustomCard";
import SupplierInfo from "./Components/SupplierInfo";
import { getSupplierById } from "../../redux/slices/supplierSlice";
import "./Supplier.scss";

const { Text } = Typography;

const SupplierDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { supplierId } = useParams();
  const { supplierDetailedData, detailsLoading } = useSelector(
    (state) => state.supplier
  );
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    if (supplierId) {
      dispatch(getSupplierById(supplierId));
    }
  }, [supplierId, dispatch]);
  const items = [
    {
      key: "1",
      label: "Supplier Details",
      children: (
        <SupplierInfo
          supplier={supplierDetailedData}
          onRefresh={() => dispatch(getSupplierById(supplierId))}
        />
      ),
    },
  ];

  return (
    <div className="supplier-details-container">
      <Flex align="center" style={{ marginBottom: 20 }}>
        <BackButton onClick={() => navigate("/suppliers")} />

        <Text className="name" style={{ marginLeft: 20 }}>
          {`Viewing Details for ${supplierDetailedData?.supplierName || "Supplier"}`}
        </Text>
      </Flex>

      <CustomCard>
        {detailsLoading ? (
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <Spin tip="Loading supplier details..." />
          </div>
        ) : (
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={items}
            className="supplier-details-tabs"
          />
        )}
      </CustomCard>
    </div>
  );
};

export default SupplierDetails;
